import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootDm.jsx'
import meta from './metaCatRootDm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(CDG|CDT|DT|DV)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'DT'},
                {type: 'DV'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DT'},
                {type: 'DV'},
                {type: 'CDT'},
                {type: 'CDG'},
            ]
        },
    })
}
